export const SET_LINEUP_SAVED_FLAG = "SET_LINEUP_SAVED_FLAG";
export const SET_GENERATED_LINEUP_COUNT = "SET_GENERATED_LINEUP_COUNT";
export const SET_SAVED_LINEUP_COUNT = "SET_SAVED_LINEUP_COUNT";
